<template>
  <div class="diagram-actions">
    <div
      role="button"
      tabindex="0"
      class="btn-container-bottom captures-description"
      @click="!$store.state.isWorkflowDisabled && $emit('add-lane')"
      :class="{ 'disabled': $store.state.isWorkflowDisabled }"
    >
      <v-icon size="small">mds:add</v-icon>
      Add lane
    </div>

    <div
      v-if="hasEvents"
      role="button"
      tabindex="0"
      class="btn-container-bottom captures-description"
      @click="!$store.state.isWorkflowDisabled && $emit('add-shape', {}, { parentEventId: 'start', createNewLaneIfNoLaneId: true })"
      :class="{ 'disabled': $store.state.isWorkflowDisabled }"
    >
      <v-icon size="small">mds:add</v-icon>
      Add start point
    </div>

    <div
      v-if="hasEvents"
      role="button"
      tabindex="0"
      class="btn-container-bottom captures-description"
      @click="!$store.state.isWorkflowDisabled && $emit('add-group', selectedEventId)"
      :class="{ 'disabled': $store.state.isWorkflowDisabled }"
    >
      <v-icon size="small">mds:add</v-icon>
      Add group
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { diagramHelpers } from '@/mixins/diagramHelpers'

export default {
  mixins: [diagramHelpers],

  props: {
    selectedEvent: Object,
    cardTypes: Array,
    baseData: Object,
    svgGraph: Object,
    svgGroups: Object,
    svgLanes: Object
  },

  data: () => ({
    commentsDialog: false,
    commentsDialogVote: null,
    feedbackDialog: false
  }),

  computed: {
    ...mapState({ workflow: state => state.workflow.workflow }),
    selectedEventId () {
      return this.$route.params.eventId
    },
    hasEvents () {
      return this.workflow?.domainEvents && this.workflow.domainEvents.length
    }
  }
}
</script>

<style scoped>
.captures-description:focus-visible {
  outline: none;
}
</style>
